// Campaign templates for the Marketing department
// Campaigns are launched from weekly slot offerings; resolved on completion day.

// ── Campaign Templates ──────────────────────────────────────────────────────
export const CAMPAIGN_TEMPLATES = [
  // ── Social Media ────────────────────────────────────────────────────────
  {
    id: 'social-media',
    type: 'social',
    name: 'Social Media Push',
    description: 'Instagram reels & influencer shoutouts. Cheap, fast, but saturates quickly.',
    cost: 350,
    durationDays: 4,
    brandDelta: 2,
    demandDelta: 0.03,
    channelAffinity: 'retail',
    qualityFloor: 30,
    saturationCost: 2,
    backlashRisk: 0.15,
    techRequired: 'D2',
  },
  // ── Print Ad ────────────────────────────────────────────────────────────
  {
    id: 'print-ad',
    type: 'print',
    name: 'Magazine Feature',
    description: 'Full-page spread in a cannabis trade magazine. Slow burn, lasting impression.',
    cost: 1200,
    durationDays: 8,
    brandDelta: 5,
    demandDelta: 0.05,
    channelAffinity: 'medical',
    qualityFloor: 50,
    saturationCost: 1,
    backlashRisk: 0.25,
    techRequired: 'D4',
  },
  // ── Strain Launch ───────────────────────────────────────────────────────
  {
    id: 'strain-launch',
    type: 'strain_launch',
    name: 'Strain Launch Event',
    description: 'Grand unveiling with samples, press kits, and tasting notes. High stakes.',
    cost: 2500,
    durationDays: 14,
    brandDelta: 8,
    demandDelta: 0.08,
    channelAffinity: 'retail',
    qualityFloor: 60,
    saturationCost: 3,
    backlashRisk: 0.40,
    techRequired: 'D4',
  },
];

// ── Slot Picker ─────────────────────────────────────────────────────────────
// Called weekly to fill availableCampaignSlots with 2-3 templates the player can launch.
export function pickWeeklySlots(state, rng) {
  const available = CAMPAIGN_TEMPLATES.filter(t =>
    !t.techRequired || state.unlockedTech?.includes(t.techRequired)
  );
  if (available.length === 0) return [];

  // Always include a social campaign if available
  const social = available.find(t => t.type === 'social');
  const rest = available.filter(t => t !== social);

  const slots = social ? [social] : [];

  // Shuffle the rest and pick 1-2 more (up to 3 total)
  const shuffled = [...rest].sort(() => rng() - 0.5);
  const pickCount = Math.min(shuffled.length, slots.length === 0 ? 3 : 2);
  for (let i = 0; i < pickCount; i++) {
    slots.push(shuffled[i]);
  }

  return slots;
}
